"use client";

import { useCallback, useState } from "react";
import { BsTrash3Fill } from "react-icons/bs";
import { type VoiceTextType, generateIcon, type Translationtype } from "utils";
import { deleteVoiceText } from "../services/voiceTextService";
import { Confirm } from "./confirm";
import { toastMessage } from "./toast";

interface DeleteVoiceTextButtonProps {
  voiceText: VoiceTextType;
  refresh: () => void;
  t: Translationtype;
}

export function DeleteVoiceTextButton({
  voiceText,
  refresh,
  t,
}: DeleteVoiceTextButtonProps) {
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  const handleDelete = useCallback(
    () => {
      deleteVoiceText(voiceText.id)
        .then((resp) => {
          if (resp.data.success) {
            toastMessage.success(t("Toast.voiceTextDeleted"));
            refresh();
          } else {
            toastMessage.error(t("Toast.errorVoiceTextDelete"));
            toastMessage.validationError(resp.data.validationErrors);
          }
        })
        .catch((error) =>
          toastMessage.error(t("Toast.errorVoiceTextDelete", error))
        );
    },
    // eslint-disable-next-line
    [voiceText]
  );

  return (
    <>
      <button
        type="button"
        title={t("Buttons.delete")}
        onClick={() => setShowConfirmation(true)}
        className="flex flex-row items-center ml-3 cursor-pointer"
      >
        {generateIcon(
          BsTrash3Fill,
          `w-[25px] h-[25px] text-error ml-2 cursor-pointer`
        )}
      </button>
      <Confirm
        handleOk={() => {
          handleDelete();
          setShowConfirmation(false);
        }}
        handleClose={() => {
          setShowConfirmation(false);
        }}
        isOpened={showConfirmation}
        okBtnText={t("Buttons.delete")}
        title={t("VoiceTexts.deleteConfirmTitle")}
        t={t}
      >
        <div className="flex flex-col gap-2 p-5">
          <Item title={t("Global.name")} value={voiceText.name} />
        </div>
      </Confirm>
    </>
  );
}

function Item({ title, value }: { title: string; value: string }) {
  return (
    <div className="flex flex-row gap-3">
      <p className="text-base font-semibold">{title}:</p>
      <p className="text-base">{value}</p>
    </div>
  );
}
